export default __webpack_public_path__ + "static/media/Parent_Illustrations-11.73cce67d.svg";